import { Variant } from '@/components/Button/Button';
import SvgLoader from '@/components/icons/Loader';
import styles from './style.module.css';

const Loader: React.FC<{ buttonType?: Variant; size?: 'XS' | 'XXL' }> = ({
  buttonType,
  size = 'XS',
}) => (
  <SvgLoader
    className={`${
      buttonType === 'primary'
        ? styles['loader-icon-primary']
        : styles['loader-icon-other']
    } ${size === 'XS' ? styles['icon-xs'] : styles['icon-xxl']}`}
  ></SvgLoader>
);

export default Loader;
